import {assert} from 'assert-ts';
import type {
  PartInt,
  PartLinkedLiterary,
  PartText,
} from 'schemaDefinition/types';
import type {LinkedRoleCode} from 'schemaDefinition/types/linkTypes';

export const getLinkPropPartFromLinkedLiterary = (
  partLinkedLiterary: PartLinkedLiterary,
  linkedRoleCode: LinkedRoleCode,
): PartInt | PartText | undefined => {
  return {
    type: assert(
      linkedRoleCode.linkProperty?.type,
      'getLinkPropPartFromLinkedLiterary: type expected',
    ),
    name: assert(
      linkedRoleCode.linkProperty?.name,
      'getLinkPropPartFromLinkedLiterary: linkProperty.name expected',
      linkedRoleCode,
    ),
    required: partLinkedLiterary.linkPropRequired,
  };
};
